import { Component, OnInit } from '@angular/core';
import { AuthService, LocalStorageService } from '@app/services';
import Mustache from "mustache";
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  output: string = "";
  val: any;
  currentUser: any;

  constructor(
    private authService: AuthService
  ) {}

  ngOnInit(): void {

    var view = {
      a: 1,
      b: 2,
      c: 6
    };

    this.output = Mustache.render("{{a}} + ({{b}} / {{c}})", view);
    this.val = eval(this.output);
    this.getCurrentUser();
  }

  getCurrentUser() {
    this.authService.me().subscribe({
      next: (res: any) => {
        this.currentUser = res.data
      }
    })
  }

}
